import { component } from 'picoapp';
const InfiniteScroll = require('infinite-scroll');

class LazyLoader {
  constructor(el, ctx) {
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.init(el);
  }

  init(el) {
    this.el = el;

    const nextPageLink = el.querySelector('.js-pageNav .nextPageLink');
    // return;
    if (!nextPageLink) {
      return;
    }

    const loader = new InfiniteScroll(el.querySelector('.Loop'), {
      path: '.js-pageNav .nextPageLink',
      history: false,
      append: '.js-lazyload > .Card',
      status: '.page-load-status',
      hideNav: '.js-pageNav',
      //button: '.view-more-button',
      loadOnScroll: true,
    });

    loader.on('append', (response, path, items) => {
      items.forEach((element) => {
        // const components = element.querySelectorAll('[data-component]');
        // this.initComponents(components);
      });
    });
  }

  initComponents(elements) {
    window.theme.Components = window.theme.Components || [];
    elements.forEach((el) => {
      const modules = el.dataset.component.split(',');
      modules.forEach((componentConstructor) => {
        new AppComponents(componentConstructor, el);
      });
    });
  }
}

export default component((node, ctx) => {
  new LazyLoader(node, ctx);
});
